module.exports = __webpack_public_path__ + "img/airbase-hotspot-5.2.502a852c.png";